// Funzione che crea il pdf con tutto il dettaglio di un ordine
import {jsPDF} from "jspdf";
import {
  CURRENCY_EURO, displayTranslations, parseAmount, parseCategoryName,
  parseGradeOverall,
  titleize,
  parseItemCondition,
  parseOrderState,
  parseEncasing,
  parseGameName, compareStrings
} from "../utils";
import 'jspdf-autotable'
import I18n from 'i18n.js.erb'
import {koruri} from "./Koruri-Regular-normal";
import {koruriBold} from "./Koruri-Bold-normal";


const tab= "        "
const space=" "

const writeBoldText = (jsPDFDocument,text, xPosition, yPosition) =>{
  jsPDFDocument.setFont('Helvetica', '', 'Bold')
  jsPDFDocument.text(text ,xPosition, yPosition)
  jsPDFDocument.setFont('Helvetica', '', '')
}

const getTableRow = (orderItem, index)=>{
  var propertyString= orderItem.product.blueprint_image.language_filter
  if(orderItem.product.blueprint_image.version && orderItem.product.blueprint_image.version !== ''){
    propertyString =  propertyString + '\n' + titleize(orderItem.product.blueprint_image.version)
  }
  if(orderItem.product.blueprint_image.rarity && !compareStrings(orderItem.product.blueprint_image.rarity, 'no rarity')){
    propertyString =  propertyString + '\n' + orderItem.product.blueprint_image.rarity
  }

  if(orderItem.product.blueprint_image.edition && !compareStrings(orderItem.product.blueprint_image.edition, 'Undefined') &&
    orderItem.product.blueprint_image.edition !== ""){
    propertyString =  propertyString + '\n' + titleize(orderItem.product.blueprint_image.edition)
  }
  if(orderItem.product.blueprint_image.released_at && orderItem.product.blueprint_image.released_at !== ''){
    propertyString =  propertyString + '\n' + orderItem.product.blueprint_image.released_at
  }

  const blueprintImageNames = displayTranslations(orderItem.product.blueprint_image.en_name, orderItem.product.blueprint_image.meta_name, orderItem.product.blueprint_image.language)
  const eraNames = displayTranslations(orderItem.product.blueprint_image.en_era_name, orderItem.product.blueprint_image.era_name, orderItem.product.blueprint_image.language)
  const expansionNames = displayTranslations(orderItem.product.blueprint_image.en_expansion_name, orderItem.product.blueprint_image.expansion_name, orderItem.product.blueprint_image.language)

  var name = blueprintImageNames[0]
  if(blueprintImageNames.length > 1){
    name = blueprintImageNames[0] + '\n(' +
      blueprintImageNames[1] + ')'
  }
  if(orderItem.product.blueprint_image.collector_number && orderItem.product.blueprint_image.collector_number !== ''){
    name = name + '\n\n' + orderItem.product.blueprint_image.collector_number
  }

  var brand = parseGameName(orderItem.product.blueprint_image.game.name)

  var category = orderItem.product.blueprint_image.blueprint.category.name

  var era = eraNames[0]
  if(eraNames.length > 1){
    era = eraNames[0] + '\n(' +
      eraNames[1] + ')'
  }

  var expansion = expansionNames[0]
  if(expansionNames.length > 1){
    expansion = expansionNames[0] + '\n(' +
      expansionNames[1] + ')'
  }

  var condition = parseItemCondition(orderItem.product.condition)
  var grading = parseGradeOverall(orderItem.grading) + '\n\n' +  I18n.t('js.PDFGenerator.order.serialNumber') + '\n' + orderItem.grading.serial_number

  var encasing = parseEncasing(orderItem.grading.encasing, orderItem.product.blueprint_image.blueprint.category.name)
  var labelLanguage = orderItem.grading.label_language.toUpperCase()

  var error = I18n.t('js.editCartPage.none')
  if(orderItem.grading.qualifier && orderItem.grading.qualifier !== "none"){
    error = titleize(orderItem.grading.qualifier.replaceAll('_', ' '))
  }

  var price = parseAmount(orderItem.price_purchase) + CURRENCY_EURO
  var translated_category = parseCategoryName(category)

  return [index, propertyString,name, brand, translated_category, era, expansion, condition, grading, encasing, labelLanguage, error, price, orderItem.state]
}

const addFooters = (doc) => {
  const pageCount = doc.internal.getNumberOfPages()

  doc.setFont('helvetica', 'italic')
  doc.setFontSize(8)
  for (var i = 1; i <= pageCount; i++) {
    doc.setPage(i)
    doc.text('Page ' + String(i) + ' of ' + String(pageCount), doc.internal.pageSize.width / 2, 205, {
      align: 'center'
    })
  }
}



export const orderDetailSellerPDF = (order, userType) => {

  const doc = new jsPDF({orientation: "landscape"});
  doc.addFileToVFS("Koruri-Regular.ttf", koruri);
  doc.addFont("Koruri-Regular.ttf", "Koruri-Regular", "normal");
  doc.addFileToVFS("Koruri-Bold-normal.ttf", koruriBold);
  doc.addFont("Koruri-Bold-normal.ttf", "Koruri-Bold", "bold");
  doc.setFont('Helvetica')
  var img = new Image()
  img.src = '/images/square.png'
  doc.addImage(img, 'png', 10, 1, 15, 15)
  doc.line(10, 18, 200, 18, 'FD')
  doc.setFontSize(18)
  doc.text(I18n.t('js.PDFGenerator.order.detailOrder') + space + order.id, 10, 26);
  doc.text(order.products_price_purchase +space+ CURRENCY_EURO, 198, 26, {align:'right'});
  doc.setFontSize(12)
  doc.text(I18n.t('js.PDFGenerator.common.createAt') + space + order.created_at.toString() + tab +
    I18n.t('js.PDFGenerator.common.numberOfProduct') + space + order.number_of_items + tab + I18n.t('js.PDFGenerator.order.orderState')+ space + parseOrderState(order.state) , 10, 35);

  if (userType=== 'seller'){
    doc.setFontSize(24)
    writeBoldText(doc, I18n.t('js.PDFGenerator.order.titleReceivedOrder'), 28, 13)
    doc.setFontSize(12)
    doc.text(I18n.t('js.PDFGenerator.order.buyer') + space  + (order?.buyer?.username ? order.buyer.username : '') + tab,10, 45);
    doc.text(I18n.t('js.PDFGenerator.common.userEmail') + space + order.buyer.email + tab,10, 55);
    if(order.shipment_address.phone_number){
      doc.text(I18n.t('js.PDFGenerator.common.userPhone') + space + order.shipment_address.phone_number + tab,10, 65);
    }
  }else {
    doc.setFontSize(24)
    writeBoldText(doc, I18n.t('js.PDFGenerator.order.titleSendedOrder'), 28, 13)
    doc.setFontSize(12)
    doc.text(I18n.t('js.PDFGenerator.order.seller') + space  + (order?.seller?.username ? order.seller.username : '') + tab,10, 45);
    doc.text(I18n.t('js.PDFGenerator.common.userEmail') + space + order.seller.email + tab,10, 55);
  }
  if (order.shipment_address) {
    doc.text(I18n.t('js.PDFGenerator.common.userAddress'),98, 45);
    doc.text(order.shipment_address.first_name + space + order.shipment_address.last_name ,98, 50);
    doc.text(I18n.t('js.PDFGenerator.common.userAddressStreet') + space + order.shipment_address.street_square + space + 
      I18n.t('js.PDFGenerator.common.userAddressStreetN') + order.shipment_address.number.toString() +
      (order.shipment_address.indoor ? ', ' + order.shipment_address.indoor : ''),98, 55);
    doc.text(order.shipment_address.cap + space + order.shipment_address.city + space ,98, 60);
    doc.text((order.shipment_address.province.toUpperCase() !== order.shipment_address.country.toUpperCase() ? order.shipment_address.province + space : '') + "(" + order.shipment_address.country + ")",98, 65);
  }
  doc.line(10, 72, doc.internal.pageSize.width - 10, 72, 'F')
  doc.text(I18n.t('js.PDFGenerator.common.products'),10, 80);
  var tableContent = []
  for(var i = 0; i < order.order_items.length; i ++) {
        tableContent.push(getTableRow(order.order_items[i], i+1))
  }
  doc.autoTable({
    theme: 'plain',
    head: [[ '',
             I18n.t('js.PDFGenerator.common.tableHeader.property'),
             I18n.t('js.PDFGenerator.common.tableHeader.name'),
             I18n.t('js.PDFGenerator.common.tableHeader.brand'),
             I18n.t('js.PDFGenerator.common.tableHeader.category'),
             I18n.t('js.PDFGenerator.common.tableHeader.era'),
             I18n.t('js.PDFGenerator.common.tableHeader.expansion'),
             I18n.t('js.PDFGenerator.common.tableHeader.condition'),
             I18n.t('js.PDFGenerator.common.tableHeader.grading'),
             I18n.t('js.PDFGenerator.order.tableHeader.encasing'),
             I18n.t('js.PDFGenerator.common.tableHeader.language'),
             I18n.t('js.PDFGenerator.order.tableHeader.error'),
             I18n.t('js.PDFGenerator.order.tableHeader.price'),
             I18n.t('js.PDFGenerator.order.tableHeader.productState')]],
    body: tableContent,
    margin: {left: 3, right: 3 },
    startY: doc.pageCount > 1 ? doc.lastAutoTable.finalY + 10 : 85,
    headStyles: {
      font: 'Koruri-Bold',
      lineWidth: 0.5,
      lineColor: [0, 0, 0],
      align: 'center'
    },
    bodyStyles:{
      font: 'Koruri-Regular',
      lineWidth: 0.3,
      lineColor: [0, 0, 0],
      align: 'center'
    },
    columnStyles: {
      2: {cellWidth: 30},
      6: {cellWidth: 30}
    },
    alternateRowStyles: {
      fillColor: [230, 230, 230]
    }
  })

  addFooters(doc)
  var pdfName= 'Order_' + order.id + '.pdf'
  doc.save(pdfName);
}
